module.exports = __webpack_public_path__ + "b6bac9a4042701240a1cf17b5e863df4.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-78.png
// module id = 145
// module chunks = 0